import type { MonitoringCharacteristics } from '@app/pages/ProcessingResultsPageInner/types'

import type {
  MonitoringDataKeys,
  PricesDataKeys
} from '@app/pages/ProcessingResultsPageInner/ui/MonitoringCharacteristics/types'

export const titlesMap: Partial<Record<keyof MonitoringCharacteristics, string>> = {
  monitoringSubtype: 'Подтип',
  monitoringType: 'Тип мониторинга',
  cluster: 'Кластер',
  store: 'ТК Лента',
  contractor: 'Подрядчик',
  competitor: 'Конкурент',
  startPromoDateAt: 'Дата начала промо',
  endPromoDateAt: 'Дата окончания промо',
  storeRegularPrice: 'Регулярная цена',
  storePromoPrice: 'Акционная цена'
}

export const monitoringDataTargetKeys: MonitoringDataKeys[] = [
  'monitoringSubtype',
  'monitoringType',
  'cluster',
  'store',
  'contractor',
  'competitor',
  'startPromoDateAt',
  'endPromoDateAt'
]

export const pricesDataTargetKeys: PricesDataKeys[] = ['storeRegularPrice', 'storePromoPrice']
